import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import getRoutes from 'base/routes';

import 'dist/styles/base.css';

class App extends Component {
  render() {
    const routes = getRoutes();
    
    return (
      <Router>
        <Switch>
          {routes}
        </Switch>
      </Router>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/base/views/App.js